/*
import React from "react";

export default function Cart() {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center">
        Nothing found here
      </div>
    </div>
  );
}
*/

import React, {useEffect, useState} from 'react';
import AuthService from "../services/auth/auth_service";
import {RadioGroup} from "@headlessui/react";
import {toast, ToastContainer} from "react-toastify";
import CartItem from "../CartItem/CartItem"
import {useNavigate} from "react-router";
import PopConfirm from "../pop up not used/PopConfirm";

const products = [
  {
    id: 1,
    name: 'Throwback Hip Bag',
    href: '#',
    color: 'Salmon',
    price: '$90.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg',
    imageAlt:
      'Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt.',
  },
  {
    id: 2,
    name: 'Medium Stuff Satchel',
    href: '#',
    color: 'Blue',
    price: '$32.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg',
    imageAlt:
      'Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch.',
  },
    {
    id: 3,
    name: 'Throwback Hip Bag',
    href: '#',
    color: 'Salmon',
    price: '$90.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg',
    imageAlt:
      'Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt.',
  },
  {
    id: 4,
    name: 'Medium Stuff Satchel',
    href: '#',
    color: 'Blue',
    price: '$32.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg',
    imageAlt:
      'Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch.',
  },
    {
    id: 5,
    name: 'Throwback Hip Bag',
    href: '#',
    color: 'Salmon',
    price: '$90.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg',
    imageAlt:
      'Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt.',
  },
  {
    id: 6,
    name: 'Medium Stuff Satchel',
    href: '#',
    color: 'Blue',
    price: '$32.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg',
    imageAlt:
      'Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch.',
  },
    {
    id: 7,
    name: 'Throwback Hip Bag',
    href: '#',
    color: 'Salmon',
    price: '$90.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg',
    imageAlt:
      'Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt.',
  },
  {
    id: 8,
    name: 'Medium Stuff Satchel',
    href: '#',
    color: 'Blue',
    price: '$32.00',
    quantity: 1,
    imageSrc:
      'https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg',
    imageAlt:
      'Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch.',
  },
  // More products...
];

      function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


export default function Cart() {
  sessionStorage.removeItem('scroll')

    const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  const [cartData, setCartData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);


  /*useEffect(() => {
    AuthService.loadCartListbyUuid(localStorage.getItem('uuid')).then((response) => {
      console.log('cart data', response.data);
      const formattedCartData = response.data.map((cart) => ({
        ...cart,
        product: cart.product.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        })),
      }));

      // Calculate the total price
      const total = response.data.reduce((acc, cart) => {
        return acc + cart.product.reduce((sum, product) => sum + product.price, 0);
      }, 0);

      setTotalPrice(total);
      setCartData(formattedCartData);
    });
  }, []);

  const removeCartItem = (product_id) => {
  AuthService.cartDeleteByProductId(localStorage.getItem('uuid'), product_id)
    .then(() => {
      // After deleting, reload the updated cart data
      AuthService.loadCartListbyUuid(localStorage.getItem('uuid'))
        .then((response) => {
          console.log('cart data', response.data);

          // Process the response data
          const formattedCartData = response.data.map((cart) => ({
            ...cart,
            product: cart.product.map((product) => ({
              ...product,
              price: product.price.toLocaleString(),
            })),
          }));

          // Calculate the total price
          const total = response.data.reduce((acc, cart) => {
            return acc + cart.product.reduce((sum, product) => sum + product.price, 0);
          }, 0);

          setTotalPrice(total);
          setCartData(formattedCartData);
        })
        .catch((error) => {
          console.error('Error loading cart data after deletion:', error);
        });

      toast.success('Umeondoa bidhaa kwenye  kikapu chako kikamilifu');
    })
    .catch((error) => {
      console.error('Error deleting cart item:', error);
    });
};

  const clearCart = () => {
      AuthService.cartClear(localStorage.getItem('uuid')).then(r=>{



              AuthService.loadCartListbyUuid(localStorage.getItem('uuid'))
        .then((response) => {
          console.log('cart data', response.data);

          // Process the response data
          const formattedCartData = response.data.map((cart) => ({
            ...cart,
            product: cart.product.map((product) => ({
              ...product,
              price: product.price.toLocaleString(),
            })),
          }));

          // Calculate the total price
          const total = response.data.reduce((acc, cart) => {
            return acc + cart.product.reduce((sum, product) => sum + product.price, 0);
          }, 0);

          setTotalPrice(total);
          setCartData(formattedCartData);
        })
        .catch((error) => {
          console.error('Error loading cart data after deletion:', error);
        });

      toast.success('Kikapu kimesafishwa kikamilifu');











      })
  }
*/


   useEffect(() => {
    AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        console.log('cart data', response.data);
        setCartData(response.data.cart_items);
        setTotalPrice(response.data.overall_total_price);
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });
  }, []);

   const updateOverallTotalPrice = (newTotalPrice) => {
    setTotalPrice(newTotalPrice);
  };


   const clearCart = () => {
     AuthService.cartClear(localStorage.getItem('uuid')).then(r=>{
 console.log('allen',r.statusText)
         if (r.statusText==='No Content'){
              AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        console.log('cart data', response.data.cart_count);
        localStorage.setItem('cart_count',response.data.cart_count)
          localStorage.getItem('cart_count')
        setCartData(response.data.cart_items);
        setTotalPrice(response.data.overall_total_price);
          /* toast.success('cart Item removed')*/
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });

         }


     })

   }




     const [selectedQty, setSelectedQty] = useState(1);
   const [selectedSize, setSelectedSize] = useState('');
 /* const sizes = cartItem.product.size.split(',').map((size) => size.trim());*/
/*  const totalPrice = totalPriceOg * selectedQty; // Calculate the total price*/
     const [showModal, setShowModal] = useState(false);



  // Format the total price as currency with thousands separators and no decimal places
  const formattedTotalPrice = new Intl.NumberFormat('sw-TZ', {
    style: 'currency',
    currency: 'TZS', // Tanzanian Shilling
    maximumFractionDigits: 0, // Remove decimal places
  }).format(totalPrice);


  console.log("caty",totalPrice)
  const [isTouched, setIsTouched] = useState(false);
   const [ispic, setIsPic] = useState('')


  const handleTouchStart = (pic) => {
      setIsPic(pic)
      setShowModal(true)
    setIsTouched(true);
  };

  const handleTouchEnd = () => {
    setIsTouched(false);
     setShowModal(false)
  };




    const removeCartItem = (id) => {

     AuthService.cartItemDeleteByUserId(localStorage.getItem('uuid'), id).then(r=>{
         console.log(r.statusText)
         if (r.statusText==='No Content'){
              AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        console.log('cart data', response.data.cart_count);
        localStorage.setItem('cart_count',response.data.cart_count)
          localStorage.getItem('cart_count')
        setCartData(response.data.cart_items);
        setTotalPrice(response.data.overall_total_price);
           toast.success('cart Item removed')
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });

         }
           localStorage.getItem('cart_count')
     })

 }




  const handleUpdateCartItem = async (e, id) => {
  const fieldName = e.target.name;
  const fieldValue = e.target.value;

  const data = {
    [fieldName]: fieldValue,
  };

  try {
    const response = await AuthService.updateCart(id, data);
    console.log('ambundo1', response.data);

    if (response.data.message === 'Cart item updated successfully') {
      // Update the local state or trigger a refresh of the cart items

        AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        console.log('cart data', response.data);
        setCartData(response.data.cart_items);
        setTotalPrice(response.data.overall_total_price);
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });


      toast.success(response.data.message);
    } else {
      console.error('Error updating cart item');
    }
  } catch (error) {
    console.error('Error updating cart item', error);
  }
};

    const handleUpdateCartItem1 = async (e, id) => {
  const fieldName = e.target.name;
  const fieldValue = e.target.value;

  const data = {
    [fieldName]: fieldValue,
  };

  try {
    const response = await AuthService.updateCart(id, data);
    console.log('ambundo1', response.data);

    if (response.data.message === 'Cart item updated successfully') {
      // Update the local state or trigger a refresh of the cart items

        AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        console.log('cart data', response.data);
        setCartData(response.data.cart_items);
        setTotalPrice(response.data.overall_total_price);
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });


      toast.success(response.data.message);
    } else {
      console.error('Error updating cart item');
    }
  } catch (error) {
    console.error('Error updating cart item', error);
  }
};


  return (

    /*<div className={` h-full inset-0 overflow-auto ${open ? 'block' : 'auto'}`}>
      <ToastContainer />
      {cartData.length > 0 && (
      <div className=" inset-0 flex justify-center ">
        <div className=" rounded-lg  w-full max-w-md p-6">
          <strong><h2 className="text-lg font-medium nav__logo  mb-4">Kikapu Ulichohifadhi</h2></strong>
           <button
               /!*onClick={()=>clearCart()}*!/
        className="bg-transparent text-red-500 font-bold py-2 px-4 rounded border-b-2 border-red-500 mr-4 hover:bg-red-100 flex items-center">
        <i className="bx bx-trash-alt text-lg mr-2"></i> Clear Cart
      </button>

          <ul className="divide-y divide-gray-200">
            {cartData[0].product.map((product) => (
              <li key={product.id} className="flex py-4">
                <div className="h-16 w-16 flex-shrink-0 bg-white overflow-hidden rounded-md border border-gray-200">
                  <img
                    src={`http://192.168.43.126:8000${product.photo}`}
                    alt={product.name}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="ml-4 flex flex-1 flex-col">
                  <div className="flex justify-between text-base font-medium text-gray-900">
                    <h3>
                      <a href={product.href}>{product.name}</a>
                    </h3>
                    <p className="ml-4 nav__logo font-bold">{product.price}</p>
                  </div>
                  <div className="mt-1 text-sm  nav__logo lowercase">

                    <RadioGroup  className="mt-4">
      <RadioGroup.Label className="sr-only">Choose a color</RadioGroup.Label>
      <div className="flex items-center space-x-3">
        {product.colors.map((color) => (
          <RadioGroup.Option
            key={color.id}
            value={color}
            className={({ active, checked }) =>
              classNames(
                active && checked ? 'ring ring-offset-1' : '',
                !active && checked ? 'ring-2' : '',
                'relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none'
              )
            }
          >
            <RadioGroup.Label as="span" className="sr-only">
              {color.name}
            </RadioGroup.Label>
            <span
              aria-hidden="true"
              className={classNames(
                'h-8 w-8 rounded-full border border-opacity-10'
              )}
              style={{ backgroundColor: color.color }}
            />
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>

                  </div>
                  <div className="flex flex-1 items-end justify-between text-sm">
                    <p className=" nav__logo lowercase">Qty {product.quantity}</p>
                    <button
                        /!*onClick={()=>removeCartItem(product.id)}*!/
                      type="button"
                      className="font-medium text-indigo-600 hover:text-indigo-500"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div className="border-t border-gray-200 pt-4 mt-4 ">
            <div className="flex justify-between text-base font-medium text-gray-900">
              <p className={'nav__logo lowercase'}>Total price</p>
              <p className={'nav__logo lowercase'}>{totalPrice.toLocaleString()} Tsh</p>
            </div>
            <p className="mt-0.5 text-sm  lowercase">
                Gharama za usafirishaji utajulishwa mwishoni bofya batani hapo chini kumaliza taarifa za
              usafirishaji
            </p>
            <div className="mt-6">
              <span
                className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white  hover:bg-indigo-700"
              >
                Bonyeza kumakamilisha
              </span>
            </div>
            <div className="mt-6 flex justify-center text-center text-sm text-gray-500" style={{visibility:'hidden'}}>
              <p>
                or{' '}
                <button
                  type="button"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                  onClick={() => setOpen(false)}
                >
                  Continue Shopping <span aria-hidden="true">&rarr;</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
        )}
    </div>
*/

      /*<div>
      {cartData.length > 0 && (
        <div>
          <h2>Products in the First Cart:</h2>
          <ul>
            {cartData[0].product.map((product) => (
              <li key={product.id}>
                {/!* Render product information here *!/}
                <p>Product Name: {product.name}</p>
                <p>Product Price: {product.price}</p>
                {/!* Add more product information as needed *!/}
              </li>
            ))}
          </ul>
        </div>
      )}
      </div>*/


      <div
            onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
            className="h-full pb-16 inset-0 overflow-auto">
      {/* Other components */}
     {cartData.length > 0 ? (
        <div className="inset-0 flex justify-center">
             <ToastContainer />
          <div className="rounded-lg w-full max-w-md p-6">
            <strong>
              <h2 className="text-lg lg:mt-10 mt-3 font-medium nav__logo mb-4">
                Kikapu Ulichohifadhi
              </h2>
            </strong>
            {/* Clear Cart button */}
            <button
               onClick={()=>clearCart()}
              className="bg-transparent text-red-500 font-bold py-2 px-4 rounded border-b-2 border-red-500 mr-4 hover:bg-red-100 flex items-center"
            >
              <i className="bx bx-trash-alt text-lg mr-2"></i> Clear Cart
            </button>

            <ul className="divide-y divide-gray-200">

             {/* {cartData.map((cartItem) => (
                <CartItem key={cartItem.id} cartItem={cartItem} updateOverallTotalPrice={updateOverallTotalPrice} />
              ))}*/}


               {cartData.map((d) => (


                  <li className="flex py-4" key={d.id}>
      <div

        className="h-16 w-16 flex-shrink-0 bg-white overflow-hidden rounded-md border border-gray-200"
      >
        <img
             onTouchStart={()=>handleTouchStart(d.product.photo)}
      onTouchEnd={handleTouchEnd}
          src={`http://kopakwetu.co.tz:8007${d.product.photo}`}
          alt={d.product.name}
          className="h-full w-full object-cover object-center"
        />

       {/* {isTouched && (
          <img
            src={`http://192.168.43.126:8000${d.product.photo}`}
            alt={d.product.name}
            className="h-full w-full object-cover object-center"
          />
        )}*/}
      </div>
      <div className="ml-4 flex flex-1 flex-col">
        <div className="flex justify-between text-base font-medium text-gray-900">
          <h3>
            <span style={{ fontWeight: 'bold' }}>{d.product.name.split('-')[0]}</span>
          </h3>
         <p className="ml-4 nav__logo font-bold">
  TZS {d.total_price.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}
</p> {/* Display total price */}
        </div>
        <div className="mt-1 text-sm nav__logo lowercase">
          {/* Display colors here */}
          Rangi:
          {d.product.colors.map((color) => (
            <div key={color.id} className="flex items-center ml-3 space-x-3">
              <span
                className="h-8 w-8 rounded-full border border-opacity-10"
                style={{ backgroundColor: color.color }}
              />
            </div>
          ))}
        </div>

        <div className="mt-1 text-sm nav__logo lowercase">
          {/* Size selection */}
          Size:
         <select
  name={'selectedSize'}
  value={d.selectedSize}
  onChange={(e) => { handleUpdateCartItem(e, d.id) }}
  className="border rounded-md p-1 ml-3 w-16 text-gray-800 text-center focus:outline-none">
  <option value={d.selectedSize}>{d.selectedSize}</option>
  {d.product.size.split(',').map((sizeOption) => (
    <option key={sizeOption} value={sizeOption.trim()}>
      {sizeOption.trim()}
    </option>
  ))}
</select>
{/*<select
  name={'selectedSize'}
  value={d.selectedSize}
  onChange={(e) => { setSelectedSize(e.target.value); handleUpdateCartItem(e, d.id) }}
  className="border rounded-md p-1 ml-2 w-16 text-gray-800 text-center focus:outline-none"
>
  {d.product.size.split(',').map((sizeOption) => {
    const trimmedSize = sizeOption.trim();
    return (
      trimmedSize !== d.selectedSize && (
        <option key={trimmedSize} value={trimmedSize}>
          {trimmedSize}
        </option>
      )
    );
  })}
</select>*/}


        </div>

        <div className="flex flex-1 items-end justify-between text-sm">
          <div className="mt-1 text-sm nav__logo lowercase">
            Idadi:
            <select
                style={{marginLeft:'2px'}}
                name={'Qty'}
              value={d.Qty}
              onChange={(e) => {setSelectedQty(e.target.value); handleUpdateCartItem(e, d.id)}}
              className="border rounded-md p-1 w-16 text-gray-800 text-center focus:outline-none"
            >
              {[1, 2, 3, 4, 5, 6, 7, 8].map((qty) => (
                <option key={qty} value={qty}>
                  {qty}
                </option>
              ))}
            </select>
          </div>
          <button
             onClick={()=>removeCartItem(d.id)}
            type="button"
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            Remove
          </button>
        </div>
      </div>
    </li>
             ))}




            </ul>

            {/* Total Price */}
            <div className="border-t border-gray-200 pt-4 mt-4">
              <div className="flex justify-between text-base font-medium text-gray-900">
                <p className={'nav__logo lowercase'}>Jumla</p>
                <p className={'nav__logo uppercase'}>
                  TZS {totalPrice}
                </p>
              </div>
              <p className="mt-0.5 text-sm lowercase">
                Fair delivery price itajumuishwa mwishoni bonyeza batani hapo chini kumaliza taarifa za
                usafirishaji
              </p>
              <div className="mt-6"
                    onClick={()=>PopConfirm.show(cartData)}>
                 {/*  onClick={()=>{navigate(`/confirm/?d=${encodeURIComponent(JSON.stringify(cartData))}`)}}*/}
                <span className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white hover:bg-indigo-700">
                  Bonyeza kulipia
                </span>
              </div>
              <div
                className="mt-2 flex justify-center text-center text-sm text-gray-500"
              >
                <p>
                  or{' '}<br/>
                  <button
                    type="button"
                    className="font-medium text-indigo-600 mt-2 hover:text-indigo-500"
                    onClick={() => navigate('/package')}
                  >
                    <i className='bx bx-arrow-back bx-fade-left mr-1'></i> Endelea kununua
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
      <div className="h-80 flex justify-center items-center">
  <div className="text-center">
    <p className="text-sm lowercase  av__logo">
      Kikapu hakina bidhaa
    </p>
  </div>
</div>

      )}





       {showModal && (
            <div
                className={`fixed inset-0 flex items-center justify-center z-50`}>
                <div className="bg-black h-80 p-4 w-80 max-w-full rounded-md shadow-lg"


                         style={{
            background: `url(http://kopakwetu.co.tz:8007${ispic})`,
            backgroundSize: "cover", // Adjust as needed
            backgroundPosition: "center", // Adjust as needed
                             backgroundColor:"black",
                              filter: 'brightness(1.12) contrast(1.1) saturate(1.2)'
          }}
                        >





            </div>
            </div>
      )}

    </div>
  );
}







            /*COMPONENT IS HOVERED*/
/*
import React, { useState } from 'react';

function Cart() {

  const [isHovered, setIsHovered] = useState(false);
   const [title, settitle] = useState(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
    settitle('jj')
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
        style={{marginTop:'200px'}}
      className="card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <h3>{title}</h3>
      <p>jjjjjjjj</p>
      {isHovered && (
        <div className="popup">
          <p>This is a popup!</p>
        </div>
      )}
    </div>
  );
}

export default Cart;
*/


/*COMPONENT IS TOUCHED*/
/*
import React, { useState } from 'react';

function Cart() {
  const [isTouched, setIsTouched] = useState(false);
  const [title, settitle] = useState(null);

  const handleTouchStart = () => {
    setIsTouched(true);
    settitle('jj');
  };

  const handleTouchEnd = () => {
    setIsTouched(false);
  };

  return (
    <div
      style={{ marginTop: '200px' }}
      className="relative card"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <h3>{title}</h3>
      <p>jjjjjjjj</p>
      {isTouched && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-90 transition-opacity duration-300">
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <p className="text-lg font-bold">This is a popup!</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cart;
*/
